import React, { useState } from "react";
import { BookmarkIcon, HeartIcon } from "@heroicons/react/outline";
import { HeartIcon as SolidHeartIcon } from "@heroicons/react/solid";
export default function JobSearchBanner({ icon, label, description, details }) {
  const [liked, setLiked] = useState(false);
  const toggleLike = () => {
    setLiked(!liked);
  };
  return (
    <div className="max-w-[420px] bg-white p-6 shadow rounded-md">
      <div className="flex justify-between">
        <img src={icon} alt="Icon" className="w-16 h-16" />
        <div className="flex gap-2 items-center">
          <button
            onClick={toggleLike}
            className="flex items-center justify-center p-2 rounded-full transition transform hover:scale-110 focus:outline-none"
          >
            {liked ? (
              <SolidHeartIcon className="h-5 w-5 text-red-500" />
            ) : (
              <HeartIcon className="h-5 w-5 text-gray-500" />
            )}
          </button>
          <button className="rounded-md bg-custom-blue p-2.5 w-8 h-8">
            <BookmarkIcon className="w-3 h-3 text-white" />
          </button>
          <button className="rounded-md bg-custom-blue p-2.5 w-8 h-8 flex justify-center items-center">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.66699 11.7083L11.3337 5.04163"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.66699 5.04163H11.3337V11.7083"
                stroke="white"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="flex flex-col gap-2.5">
        <p className="text-midnight-blue text-lg font-semibold">{label}</p>
        <p className="text-border-gray text-base font-normal">{description}</p>
        {details?.length > 0 && (
          <div className="flex gap-2">
            {details.map((detail, index) => (
              <React.Fragment key={index}>
                {detail.modal && (
                  <div className="text-white text-xs font-semibold bg-custom-blue px-2 py-1 rounded">
                    {detail.modal}
                  </div>
                )}
                {detail.salary && (
                  <div className="text-white text-xs font-semibold bg-custom-blue px-2 py-1 rounded">
                    {detail.salary}
                  </div>
                )}
                {detail.location && (
                  <div className="text-white text-xs font-semibold bg-custom-blue px-2 py-1 rounded">
                    {detail.location}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
